import api from '@/utils/api'

export default {
    getArticles(page, size, team = '') {
        const range = `?page=${page}&per_page=${size}`
        const teamParam = (team === 0 || team) ? `&team=${encodeURIComponent(team)}` : ''
        return api.get('article/filtered' + (page ? range : '') + `&sort=${encodeURIComponent('[date, DESC]')}` + teamParam)
    },

    getArticle(id) {
        return api.get(`article/${id}`)
    }
}
